import ShipmentNoticeProgressBar from './shipment-notice-progress-bar';

export default ShipmentNoticeProgressBar;